export class ImportStudent{ 
    tenFile: string;
    ketQuaImport: string;
    // kyThi : any;
    // hoiDong : any;
    // monThi : any;
    // tuiBaiThi : any;
    constructor(){
        this.tenFile = '';
        this.ketQuaImport = '';
    }
}